<footer class="footer" *ngIf='appService.appData.value.domain'>
	<div class="container">
		<div class="row toggle-mobile footer-blocks">
			<div [ngClass]="{
				'col-xl-6 col-lg-6': links,
				'col-xl-9 col-lg-9': !links
			}" class="col-md-12 col-sm-12 col-xs-12 language-switcher">
				<!-- logo footer -->
				<ng-container *ngIf='appService.Logo'>
					<img [src]="appService.getBaseServerAddress() + '/document_files/download/' + appService.Logo" class="logo" />
				</ng-container>

				<!-- language -->
				<label>{{'Lingua' | translate}}</label>
				<language-switcher></language-switcher>

				<!--<label>{{'Chi siamo' | translate}}</label>
				<div class="intro">
					<p>{{'Un team di ninja appassionati di tecnologia e marketing che offrono sistemi integrati di viaggio facili da usare "all\'avanguardia"' | translate}}.</p>
					<p>{{'Il viaggio è la nostra passione, la tecnologia user friendly e il know-how il nostro proiettile d\'argento' | translate}}.</p>
				</div>-->

				<p class="copyright">&copy; {{Year}} Tangerine. {{'Sviluppato da The Orange Seed' | translate}}.</p>
			</div>
			<!--<div class="col-xl-2 col-lg-6 col-md-12 col-sm-12 col-xs-12 footer-block">
				<label (click)='toggleContent("supporto")' [ngClass]='isToggleActive["supporto"] ? "open-toggle": ""'>{{'Supporto' | translate}}</label>
				<ul class="toggle-content" [ngClass]='isToggleActive["supporto"] ? "active": ""'>
					<li><a href="#">Contatti</a></li>
					<li><a href="#">Informazioni legali</a></li>
					<li><a href="#">Normativa sulla privacy</a></li>
					<li><a href="#">Condizioni d'uso</a></li>
				</ul>
			</div>
			<div class="col-xl-2 col-lg-6 col-md-12 col-sm-12 col-xs-12 footer-block">
				<label (click)='toggleContent("azienda")' [ngClass]='isToggleActive["azienda"] ? "open-toggle": ""'>Azienda</label>
				<ul class="toggle-content" [ngClass]='isToggleActive["azienda"] ? "active": ""'>
					<li><a href="#">Chi siamo</a></li>
					<li><a href="#">Lavora con noi</a></li>
					<li><a href="#">Blog</a></li>
					<li><a href="#">Rassegna stampa</a></li>
					<li><a href="#">Buono regalo</a></li>
					<li><a href="#">Magazine</a></li>
				</ul>
			</div>-->
			<div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 footer-block domain_info">
				<label (click)="toggleContent('info')" [ngClass]='isToggleActive["info"] ? "open-toggle" : ""'>Info <i class="bi bi-chevron-down"></i></label>
				<div class="toggle-content" [ngClass]='isToggleActive["info"] ? "active" : ""' *ngIf="entity">
					<span *ngIf='entity.description'>{{entity.description}}</span>
					<span *ngIf='Address'>{{Address}}</span>
					<span *ngIf='entity.phone_number'>{{'Tel' | translate}}: {{entity.phone_number}}</span>
					<span class="link" *ngIf='entity.primary_email'>{{'Email' | translate}}: <a [href]="'mailto:' + entity.primary_email">{{entity.primary_email}}</a></span>
					<span *ngIf='entity.piva'>{{'P.IVA' | translate}} {{entity.piva}}</span>
					<span class="link" *ngIf='entity.website_url'>{{'Sito web' | translate}}: <a [href]='"http://" + entity.website_url' target="_blank">{{entity.website_url}}</a></span>

					<!--<div class="social">
						<a href="#" class="fa fa-facebook-f"></a>
						<a href="#" class="fa fa-instagram"></a>
						<a href="#" class="fa fa-twitter"></a>
					</div>-->
				</div>
			</div>

			<div *ngIf="links" class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 footer-block domain_info">
				<label (click)="toggleContent('legal_info')" [ngClass]='isToggleActive["legal_info"] ? "open-toggle" : ""'>{{'Legal information' | translate}} <i class="bi bi-chevron-down"></i></label>
				<div class="toggle-content" [ngClass]='isToggleActive["legal_info"] ? "active" : ""'>
					<span class="link" *ngFor="let link of links"><a [href]='link.url' target="_blank">{{link.label}}</a></span>
				</div>
			</div>
		</div>
	</div>
</footer>
